var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { render, h, cloneVNode } from "vue";
import _sfc_main from "../components/ui/tooltip/TooltipWrapper.js";
const tooltipMap = /* @__PURE__ */ new WeakMap(), tooltip = {
  mounted(el, binding, vnode) {
    if (binding.value === void 0 || binding.value === null || binding.value === "" || el.dataset.tooltipProcessed)
      return;
    el.dataset.tooltipProcessed = "true";
    const clonedVNode = cloneVNode(vnode, {}, !1);
    clonedVNode.dirs && (clonedVNode.dirs = clonedVNode.dirs.filter((dir) => dir.dir && dir.dir.mounted !== tooltip.mounted));
    const modifiers = binding.modifiers;
    let placement;
    modifiers.top ? placement = "top" : modifiers.bottom ? placement = "bottom" : modifiers.left ? placement = "left" : modifiers.right && (placement = "right");
    const container = document.createElement("span");
    container.style.display = "contents", el.parentElement && el.parentElement.insertBefore(container, el);
    const tooltipNode = h(_sfc_main, {
      content: binding.value,
      placement
    }, { default: /* @__PURE__ */ __name(() => clonedVNode, "default") });
    render(tooltipNode, container), tooltipMap.set(el, {
      container,
      originalVNode: clonedVNode,
      content: binding.value,
      placement
    }), el.remove();
  },
  updated(el, binding) {
    if (binding.value === void 0 || binding.value === null || binding.value === "")
      return;
    const tooltipInfo = tooltipMap.get(el);
    if (tooltipInfo && tooltipInfo.originalVNode) {
      const modifiers = binding.modifiers;
      let placement;
      if (modifiers.top ? placement = "top" : modifiers.bottom ? placement = "bottom" : modifiers.left ? placement = "left" : modifiers.right && (placement = "right"), tooltipInfo.content !== binding.value || tooltipInfo.placement !== placement) {
        const tooltipNode = h(_sfc_main, {
          content: binding.value,
          placement
        }, { default: /* @__PURE__ */ __name(() => tooltipInfo.originalVNode, "default") });
        render(tooltipNode, tooltipInfo.container), tooltipInfo.content = binding.value, tooltipInfo.placement = placement;
      }
    }
  },
  unmounted(el) {
    const tooltipInfo = tooltipMap.get(el);
    tooltipInfo && (render(null, tooltipInfo.container), tooltipInfo.container.parentElement && tooltipInfo.container.parentElement.removeChild(tooltipInfo.container)), tooltipMap.delete(el);
  }
};
export {
  tooltip as default
};
